import React, { useEffect, useState } from "react";
import { Stack, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useLocation } from "react-router-dom";
import SideNavLink from "components/base/SideNavLink";
import { SUBMISSION_FOLDERS_UPDATED_EVENT, useTeacherSubmissionFolders } from "../hooks";
import { submissionFolderPath } from "../utils";

export default function SubmissionFolderNav() {
  const { folders, refresh } = useTeacherSubmissionFolders();
  const [archivesExpanded, setArchivesExpanded] = useState(false);
  const location = useLocation();

  // Opening a submission leaves the folder route, so keep its folder highlighted from
  // the ID the folder page passed along.
  const openFolderId = location.state?.submissionFolderID ?? null;

  useEffect(() => {
    const refreshNavigation = () => refresh().catch(() => {});
    window.addEventListener(SUBMISSION_FOLDERS_UPDATED_EVENT, refreshNavigation);
    return () => window.removeEventListener(SUBMISSION_FOLDERS_UPDATED_EVENT, refreshNavigation);
  }, [refresh]);

  const active = folders.filter((folder) => !folder.isArchived_ysn);
  const archived = folders.filter((folder) => folder.isArchived_ysn);

  const folderLink = (folder) => {
    const isOpen =
      openFolderId != null &&
      Number(openFolderId) === Number(folder.submissionFolderID_ids);
    return (
      <SideNavLink
        key={folder.submissionFolderID_ids}
        to={submissionFolderPath(folder)}
        className={({ isActive }) =>
          `side-nav-link${isActive || isOpen ? " active" : ""}`
        }
      >
        {folder.folderName_chr}
      </SideNavLink>
    );
  };

  return (
    <React.Fragment>
      <Stack gap={0.5} sx={{ maxHeight: "35vh", overflowY: "auto", overflowX: "auto" }}>
        {active.map(folderLink)}
      </Stack>
      <Stack
        direction="row"
        alignItems="center"
        gap={1}
        sx={{ pr: 3, cursor: "pointer" }}
        onClick={() => setArchivesExpanded((previous) => !previous)}
      >
        {archivesExpanded ? (
          <ExpandMoreIcon sx={{ color: "primary.main" }} />
        ) : (
          <ChevronRightIcon sx={{ color: "primary.main" }} />
        )}
        <Typography variant="h6" color="primary.dark" fontStyle="italic">
          Archives
        </Typography>
      </Stack>
      {archivesExpanded && (
        <Stack gap={0.5} sx={{ maxHeight: "20vh", overflowY: "auto", overflowX: "auto" }}>
          {archived.length > 0 ? (
            archived.map(folderLink)
          ) : (
            <Typography variant="body2" color="text.secondary" sx={{ pl: 4 }}>
              No archived folders
            </Typography>
          )}
        </Stack>
      )}
    </React.Fragment>
  );
}
